import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { injectModels } from "../../redux/injectModels";
import { useEffect, useRef } from "react";

function CategorySlider(props) {
  const sliderRef = useRef(null);
  var settings = {
    slidesToShow: 7,
    slidesToScroll: 7,
    dots: false,
    focusOnSelect: false,
    variableWidth: false,
    infinite: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const categoryImages = {
    "Art & Antiques": "/assets/images/art-antiques.png",
    Sporting: "/assets/images/all-event-icon3.png",
    "Music Festivals": "/assets/images/all-event-icon1.png",
    Clubs: "/assets/images/clubs.png",
    Agricultural: "/assets/images/all-event-icon4.png",
    "Seasonal Event": "/assets/images/seasonal-event.png",
    Exhibitions: "/assets/images/all-event-icon6.png",
    Concerts: "/assets/images/concerts.png",
    Fairs: "/assets/images/fair.png",
    Conventions: "/assets/images/conventions.png",
    Conferences: "/assets/images/conferences.png",
    "Food and Drink": "/assets/images/food-drink.png",
    Educational: "/assets/images/educational.png",
    "Popular Culture": "/assets/images/popular-culture.png",
    Community: "/assets/images/community.png",
    Markets: "/assets/images/markets.png",
  };

  const goToSlide = () => {
    if (sliderRef.current) {
      const index = props.application.categories.findIndex(
        (category) => category.id === props.activeCategory
      );
      if (index !== -1) {
        sliderRef.current.slickGoTo(index);
      }
    }
  };

  useEffect(() => {
    goToSlide();
  }, [props.activeCategory]);

  return (
    <Slider classNameName="slider slider-nav" ref={sliderRef} {...settings}>
      {props.application.categories.map((category, index) => {
        const imageUrl =
          categoryImages[category?.name] || "/assets/images/all-event-icon1.png";

        return (
          <ul key={index} className="tabs">
            <li
              onClick={() => {
                props.onCategoryChange(category);
              }}
              className={category?.id === props?.activeCategory ? "active" : ""}
              data-cont=".one"
            >
              <img src={imageUrl} alt={category?.name} />
              {category?.name}
            </li>
          </ul>
        );
      })}
    </Slider>
  );
}

export default injectModels(["application"])(CategorySlider);
